import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Workspaces } from '@air/api';
import { callAirApi } from '@air/utils-api';

import { getSubscriptionKey } from '~/swr-hooks/subscriptions/useSubscription';
import { UPDATE_CREDIT_PACKS_PREVIEW } from '~/swr-hooks/subscriptions/useUpdateCreditPacksPreview';
import { getCreditStatsKey } from '~/swr-hooks/workspaces/useCreditStats';

export type UseUpdateCreditPacksParams = NonNullable<Parameters<typeof Workspaces.Subscriptions.CreditPacks.update>[0]>;

export const useUpdateCreditPacks = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UseUpdateCreditPacksParams) =>
      callAirApi(() => Workspaces.Subscriptions.CreditPacks.update(params)),
    onSuccess: (_, params) => {
      queryClient.invalidateQueries({ queryKey: getSubscriptionKey(params.workspaceId) });
      queryClient.invalidateQueries({ queryKey: getCreditStatsKey({ workspaceId: params.workspaceId }) });
      queryClient.invalidateQueries({ queryKey: [UPDATE_CREDIT_PACKS_PREVIEW] });
    },
  });
};
